/**
 * Created by shubham on 27/4/18.
 */

import { Component, Input } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpService } from '../shared/services/http.service'
import { MdDialog } from '@angular/material';
import { CommonService } from '../shared/services/common.service';
import { DialogComponent } from '../dialog/dialog.component';
import { DashboardActionDialogComponent } from '../dialog/dialog.component';
import { ApplicationDashboardActionDialogComponent } from '../dialog/dialog.component';

@Component({
    selector:'multi-approve-reject',
    template: require('./multi-approve-reject.component.html')
})

export class MultiApproveRejectComponent {
    @Input() childData: any;
    @Input() searchedFilters: any;
    @Input() dashboard: any;
    @Input() selectedCount: any;
    @Input() count: any;
    @Input() totalCount: any;
    settingSingleField = {
        singleSelection: true,
        text:"Select Role",
        labelKey: "name",
        selectAllText:'Select All',
        unSelectAllText:'UnSelect All',
        classes:"myclass custom-class",
        disabled: false
    };
    settingMultipleField = {
        singleSelection: false,
        text:"Select Role",
        labelKey: "name",
        selectAllText:'Select All',
        unSelectAllText:'UnSelect All',
        classes:"myclass custom-class",
        disabled: false
    };
    dialogRef;

    constructor(private router: Router, private route: ActivatedRoute, private httpService: HttpService,
                private dialog: MdDialog, private commonService: CommonService) {
    }

    public checkStatus(status){
        if(this.dashboard == "applicationManagerView"){
            let applicationId = 0;
            for(let data in this.childData){
                if(this.childData[data]['applicationId']){
                    applicationId = this.childData[data]['applicationId'];
                    break;
                }
            }

            if(status == 'approved'){
                this.getApplicationRoles(applicationId, status);
            } else {
                this.performAction(status, applicationId,'');
            }
        } else {
            this.performAction(status, '', '');
        }
    }

    public getApplicationRoles(applicationId, status) {
        this.httpService.getRequest('applicationOperationApi/v1/applicationRoles/'+applicationId).subscribe(
            res => { this.saveApplicationRoles(res, applicationId, status); },
            err => { this.httpService.onEnd(); }
        );
    }
    public saveApplicationRoles(res, applicationId, status){
        this.httpService.onEnd();
        if(res && res.applicationRoles){
            this.performAction(status, applicationId, res);
        }
    }

    public performAction(status, applicationId, res) {
        if(this.dashboard == "applicationManagerView"){
            this.dialogRef = this.dialog.open(ApplicationDashboardActionDialogComponent);
            this.dialogRef.componentInstance.row = this.childData;
            this.dialogRef.componentInstance.roles = res.applicationRoles;
            if(res.multipleRole){
                this.dialogRef.componentInstance.settings = this.settingMultipleField;
            } else {
                this.dialogRef.componentInstance.settings = this.settingSingleField;
            }
        } else {
            this.dialogRef = this.dialog.open(DashboardActionDialogComponent);
            this.dialogRef.componentInstance.row = '';
        }

        let actionStatus;
        if(status == 'approved'){
            actionStatus = 'APPROVE';
            this.dialogRef.componentInstance.isApproved = true;
        }else if(status == 'rejected'){
            actionStatus = 'REJECT';
            this.dialogRef.componentInstance.isReject = true;
        }

        this.dialogRef.componentInstance.multiApproveRejectFlag = true;
        this.dialogRef.componentInstance.actionStatus = actionStatus;
        this.dialogRef.componentInstance.dashboard = this.dashboard;

        if(this.selectedCount < this.count){
            this.dialogRef.componentInstance.condition1Flag = true;
        } else if(this.selectedCount >= this.count && this.selectedCount < this.totalCount){
            this.dialogRef.componentInstance.condition2Flag = true;
        } else if(this.selectedCount == this.totalCount){
            this.dialogRef.componentInstance.condition3Flag = true;
        }

        this.dialogRef.afterClosed().subscribe(result => {
            if(result) {
                let data = {};

                if(this.childData){
                    if(this.dashboard == "applicationManagerView"){
                        data['applicationId'] = applicationId;
                        data['userApplicationIds'] = [];
                    } else {
                        data['userIds'] = [];
                    }

                    if(result.selectedRadioValue == "Approve All"){
                        data['allSelected'] = true;
                    } else{
                        data['allSelected'] = false;
                        for(let c in this.childData){
                            if(this.childData[c]['id']){
                                if(this.dashboard == "applicationManagerView"){
                                    data['userApplicationIds'].push(this.childData[c]['id']);
                                } else {
                                    data['userIds'].push(this.childData[c]['id']);
                                }
                            }
                        }
                    }

                    if(status == 'approved'){
                        if(this.dashboard == 'admin' || this.dashboard == 'partners'){
                            data['status'] = 'BU_APPROVE';
                            // data['roleIds'] = result.roleId;
                        } else {
                            data['status'] = 'APPROVED';
                            data['selectedRoles'] = result.selectedRoles;
                        }
                    }else if(status == 'rejected'){
                        if(this.dashboard == 'admin' || this.dashboard == 'partners'){
                            data['status'] = 'BU_REJECT';
                        } else {
                            data['status'] = 'REJECTED';
                        }
                        data['message'] = result.reason;
                    }

                    data['email'] = this.searchedFilters.email?this.searchedFilters.email:'';
                    data['firstName'] = this.searchedFilters.firstName?this.searchedFilters.firstName:'';
                    data['wpassId'] = this.searchedFilters.wpassId;
                }

                if(this.dashboard == 'admin' || this.dashboard == 'partners'){
                    this.httpService.postRequest(data,'userRegistrationsApi/v1/bulkApproveBusinessUnit').subscribe(
                        res => {
                            this.checkResponse(res, status, data['allSelected']);
                        },
                        err => { this.httpService.onEnd(); }
                    );
                } else {
                    this.httpService.postRequest(data,'applicationOperationApi/v1/bulkActionUserApplication').subscribe(
                        res => {
                            this.checkResponse(res, status, data['allSelected']);
                        },
                        err => { this.httpService.onEnd(); }
                    );
                }
            }
            this.dialogRef = null;
        });
    }

    public checkResponse(res, status, allSelected) {
        if(allSelected){
            setTimeout(()=>{
                this.httpService.onEnd();
                this.saveResponse(res, status);
            }, 15000);
        } else {
            this.httpService.onEnd();
            this.saveResponse(res, status);
        }
    }

    public saveResponse(res, status){
        let statusTxt;
        if(res){
            if(status == 'approved'){
                statusTxt = 'after_user_creation_approval_notify';
            } else{
                statusTxt = 'Rejected Successfully';
            }
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = statusTxt;

            this.dialogRef.afterClosed().subscribe(result => {
                if(this.dashboard == 'admin'){
                    this.commonService.changeAdminDashboardData();
                } else if(this.dashboard == 'partners'){
                    this.commonService.changePartnersDashboardData();
                } else if(this.dashboard == 'applicationManagerView'){
                    this.commonService.changeApplicationDashboardData();
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/multi-approve-reject/multi-approve-reject.component.ts